import React from 'react';

import {ReactComponent as BackTwoChevron} from 'images/common/BackTwoChevron.svg';
import {PLAYLIST_VISIBILITY} from 'stores/CoachingPlaylistStore';
import './TitleBar.styl';
import classNames from 'classnames';

interface Props {
  onToggle: () => void;
  visibility: string;
}

const TitleBar: React.FC<Props> = ({onToggle, visibility}) => (
  <div
    className="listening-assistant-title"
    onClick={e => {
      e.stopPropagation();
      onToggle();
    }}>
    <div
      className={classNames('header-icon pointer', {
        shown: visibility === PLAYLIST_VISIBILITY.shown,
      })}>
      <BackTwoChevron />
    </div>
    <div className="title">
      <h4>Questions For Review</h4>
    </div>
  </div>
);

export default TitleBar;
